// @ts-nocheck
/* eslint-disable */
import { CHEVRON_LEFT_16, SHARE_FILLED_16 } from "@sznds/icons";
import Header from "~/ui/header";
import createHeaderButton from "~/ui/headerbutton";
import HomeAndWork2 from "./homeandwork/index";
import { addListener } from "~/lib/signals";
import { store } from "~/state/store";
import { watch, watchCurrentUser } from "~/state/util";
import { _ } from "~/i18n";
import Scene from "~/scene";
import List from "~/places/list";
import { isDetailActive } from "~/util/detail";
import { MYMAPS_MULTIPLE } from "~/ui/sds-compatible-icons";

export default class ListComp {
	_header: Header;

	constructor(owner) {
		this._owner = owner;
		this._dom = {
			container: null,
		};
		this._layer = Scene.createLayerMarker();
		this._homeAndWork = new HomeAndWork2(this._layer);
		this._active = false;
		this._list = new List({
			owner: this,
			layer: this._layer,
			cb: data => {
				switch (data.name) {
					case "multiple-mode-open":
						this._homeAndWork.hide();
						break;

					case "multiple-mode-close":
						this._homeAndWork.show();
						break;
				}
			}
		});
		this._dom.container = this._list.getContainer();

		this._buildHeader();

		this._keepData = false;
		this._topY = 0;
		this._scrollNode = Mapy.getComponent("layout").getScrollNode();

		addListener(this, "detail-activated", () => {
			this._list.activeDetail(true);
		});

		addListener(this, "detail-deactivated", () => {
			this._list.activeDetail(false);
		});

		addListener(this, "gpx-activated", () => {
			if (this._active) {
				this._layer.disable();
			}
		});

		addListener(this, "gpx-deactivated", () => {
			if (this._active) {
				this._layer.enable();
			}
		});

		const w = watch(store.getState, "user", watchCurrentUser);
		this._storeUnsubscribe = store.subscribe(w((newUser) => {
			if (!this._active) {
				return;
			}

			this._homeAndWork.setEmptyItems();

			if (newUser.user.userPublicId && newUser.user.state === 'green') {
				this._header.avatar = newUser.user.avatar;
			} else {
				this._list.setFolderId();
				this._list.clean();

				this._keepData = false;
			}

			this._homeAndWork.closeEdit();
		}));
	}

	destroy() {
		this._storeUnsubscribe();
	}

	get active() {
		return this._active;
	}

	get shareData() {
		return this._list.shareData;
	}

	get showLabel() {
		return this._owner.showLabel;
	}

	changePublic(state) {
		this._list.shareData.public = state;
	}

	set keepData(state) {
		this._keepData = state;
	}

	notifyLikeCreate(folderId) {
		if (this._active && !folderId) {
			this._list.clean();
			this._list.load();
		}
	}

	clearFolderId() {
		this._list.setFolderId();
	}

	notifyLikeUpdate() {
		if (this._active) {
			this._list.clean();
			this._list.load();
			this._list.lookup.lookup();
		}
	}

	_buildHeader() {
		const { user } = store.getState().user;

		this._header = new Header({
			title: _("detail.content.mymapsplace.saved2"),
			avatar: user.avatar,
			premium: user.premium ? "mapy" : "none",
		});
		this._list.listHeader.prepend(this._header.node);

		const backButton = createHeaderButton({
			icon: CHEVRON_LEFT_16,
			innerHTML: _("mymap.stateswitch"),
		});
		backButton.addEventListener("click", () => {
			this._list.setMultipleMode(false);
			Mapy.getComponent("mymaps").activeComponent(Mapy.getComponent("dashboard"));
			Scene.clearAllWasmContent();
			Mapy.getComponent("history").save();
		});
		backButton.setAttribute("data-log-text", "backToDashboard");
		this._header.leftButtons.appendChild(backButton);

		const multipleButton = createHeaderButton({
			icon: MYMAPS_MULTIPLE,
			className: "header-multiple-btn",
		});

		multipleButton.addEventListener("click", () => {
			this._list.setMultipleMode(true);
		});

		this._header.rightButtons.appendChild(multipleButton);

		// FIXME: neni jak sdilet, neni publicId uzivatele
		/*
		const shareButton = createHeaderButton({
			icon: SHARE_FILLED_16,
			innerHTML: _("mymap.contextMenu.share"),
		});
		this._header.rightButtons.appendChild(shareButton);
		shareButton.addEventListener("click", () => {
			let sharePopup = new Mapy.MyMapsShare({
				type: "entity",
				url: `${location.protocol}//${location.host}/?up=${this._user?.id}&ups=mista-trasy`,
			}, function() {
				sharePopup.destroy();
				sharePopup = null;
			});
			sharePopup.open();
		});
		*/
	}

	activate() {
		if (this._active) return;

		this._homeAndWork.show();
		this._list.addHomeWork(this._homeAndWork.container);
		this._owner.container.appendChild(this._dom.container);
		Scene.addLayer(this._layer).enable();
		this._list.lookup.start();
		this._list.lookup.lookup();
		window.addEventListener("resize", this._list, false);

		Scene.getContainer().addEventListener("photo-gallery-close", this);
		Scene.getContainer().addEventListener("photo-detail-close", this);

		this._active = true;
		this._list.active = this._active;

		const { avatar, premium } = store.getState().user.user;

		if (avatar) {
			this._header.avatar = avatar;
			this._header.premium = premium ? "mapy" : "none";
		}
	}

	deactivate(keepData) {
		if (!this._active) return;

		if (keepData) {
			this._topY = this._scrollNode.scrollTop;
		}

		this._list.removeHomeWork(this._homeAndWork.container);
		this._dom.container.remove();

		this._keepData = keepData;

		if (!keepData) {
			this._list.setFolderId();
			this._list.clean();
		}

		this._layer.disable();
		Scene.removeLayer(this._layer);
		this._list.lookup.stop();
		window.removeEventListener("resize", this._list, false);

		Scene.getContainer().removeEventListener("photo-gallery-close", this);
		Scene.getContainer().removeEventListener("photo-detail-close", this);

		this._active = false;
		this._list.active = this._active;
	}

	set state(state) {
		this._homeAndWork.load();

		if (!this._keepData) {
			// pokud na to sahame tak brzy, ze historie jeste nezije, tak je to urcite z historie
			let fromHistory = Mapy.getComponent("history") ? Mapy.getComponent("history").isFromHistory() : true;
			this._list.load(state.data).then(() => {
				if (isDetailActive(store.getState())) {
					this._list.activeDetail(true);
				}

				if (Mapy.getComponent("places").isActive && state.zoomToItems && !fromHistory) {
					this._list.zoomToItems();
				}
				else {
					this._list.lookup.lookup();
				}

				Mapy.getComponent("logger").log("placesSorting", { origin: "places", value: this._list.sortType });
			}, () => {});
		}
		else {
			this._scrollNode.scrollTop = this._topY || 0;
		}
	}

	clear() {
		this._layer.removeAll();
		this._homeAndWork.clear();
		this._list.lookup.clean();
	}

	handleEvent(e) {
		if (e.type == "photo-detail-close" || e.type == "photo-gallery-close") {
			this._active && !Mapy.getComponent("gallery").isActive() && this._list.setSEO();
		}
	}

	activeSetState(opts: { refreshOnActivate: boolean; }) {
		this._list.setMultipleMode(false);
	}
}
